import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AnnouncementBar from './components/AnnouncementBar';
import FeaturedArticles from './components/FeaturedArticles';
import StatsBanner from './components/StatsBanner';
import MembershipPreview from './components/MembershipPreview';
import LatestUpdates from './components/LatestUpdates';
import { OrganizationSchema, WebsiteSchema, WebPageSchema } from '@/components/feature/SeoSchema';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <OrganizationSchema />
      <WebsiteSchema />
      <WebPageSchema
        title="琉璃神社官方 - 官方正版资源与最新公告"
        description="琉璃神社官方网站，提供最新官方公告、正版资源下载、会员服务及社区互动。关注琉璃神社官方动态，获取第一手资讯、独家内容与官方授权素材。"
        url="https://liulishenshe.com"
      />

      <Navbar />
      <main>
        <HeroSection />
        <AnnouncementBar />
        <FeaturedArticles />
        <StatsBanner />
        <MembershipPreview />
        <LatestUpdates />
      </main>
      <Footer />
    </div>
  );
}